import { isEmpty } from '../utils/baseHelpers';

const localeConfigs = {
  au: {
    ecCountryCode: 'AU',
    locale: 'en-AU',
    currency: 'AUD',
    currencySymbol: '$', // See also: getCurrencySymbol in helpers
    minDiscount: 15,
    blockedRoutes: [],
    whiteLabelBlocked: false,
    opposBlocked: false,
    goalsBlocked: false,
    takeawayBlocked: false,
    partnerFaqUrl: 'https://eatclub.com.au/partners/faqs',
    supportPhone: '02 6190 8990',
    supportEmail: 'CS@eatclub.com.au',
    settlementGuide: 'https://eccdn.com.au/partnerportal/Settlement%20guide%20AU.pdf',
    welcomeGuide: 'https://eccdn.com.au/partnerportal/Welcome%20Guide%20AU.pdf',
    paymentProvider: 'stripe',
  },
  uk: {
    ecCountryCode: 'UK',
    locale: 'en-UK',
    currency: 'GBP',
    currencySymbol: '£',
    minDiscount: 25,
    blockedRoutes: [
      '/oppo/:oppoId',
      '/alloppos/:restId',
      '/booking-confirm/:bookingId',
      '/booking-call/:bookingId',
      '/billing',
      '/menus',
      '/livebookings',
      '/livebookings/runsheet',
      '/livebookings/floorplan',
      '/livebookings/floorplan/edit',
      '/livebookings/timeline',
      '/livebookings/monthly',
      '/livebookings/guestbook',
      '/livebookings/settings',
      '/livebookings/integrations',
      '/livebookings/integrations/fbmarketplace',
      '/goals/previous',
      '/goals/create',
      '/goals/edit/:goalId',
      '/goals/:goalId',
    ],
    whiteLabelBlocked: true,
    opposBlocked: true,
    goalsBlocked: true,
    takeawayBlocked: true,
    partnerFaqUrl: 'https://eatclub.co.uk/partners/faqs',
    supportPhone: '07441 915 597',
    supportEmail: 'hello@eatclub.co.uk',
    settlementGuide: 'https://eccdn.com.au/partnerportal/Settlement%20guide%20UK.pdf',
    welcomeGuide: 'https://eccdn.com.au/partnerportal/Welcome%20Guide%20UK.pdf',
    paymentProvider: 'airwallex',
  },
};

/**
 * Get the config for the locale
 * Allows providing a locale as parameter, otherwise uses the env's locale
 * @param locale
 * @returns {*|{ecCountryCode: string, locale: string, currency: string, minDiscount: number, blockedRoutes: [], whiteLabelBlocked: boolean, opposBlocked: boolean, goalsBlocked: boolean, takeawayBlocked: boolean, partnerFaqUrl: string, supportPhone: string, supportEmail: string, settlementGuide: string}}
 */
export const getAppConfig = (locale = null) =>
  localeConfigs?.[locale] ?? localeConfigs[import.meta.env.VITE_LOCALE] ?? localeConfigs.au;

/**
 * Get the locale for the restaurant. This comes from the country code
 * @param restaurant
 * @returns {string}
 */
export const getRestaurantLocale = (restaurant) => {
  // Fall back to env if restaurant has no country
  if (
    restaurant?.countryCode === null ||
    restaurant?.countryCode === undefined ||
    restaurant?.countryCode === ''
  ) {
    return import.meta.env.VITE_LOCALE;
  }

  return restaurant?.countryCode === 'UK' ? 'uk' : 'au';
};

// TODO replace most getAppConfig calls with this so that we can view stats in the specific restaurant's locale
export const getRestaurantConfig = (restaurant) => {
  return getAppConfig(getRestaurantLocale(restaurant));
};
